import { render, staticRenderFns } from "./ExamInternalHeader.vue?vue&type=template&id=1ea4856b&scoped=true&"
import script from "./ExamInternalHeader.vue?vue&type=script&lang=js&"
export * from "./ExamInternalHeader.vue?vue&type=script&lang=js&"
import style0 from "./ExamInternalHeader.vue?vue&type=style&index=0&id=1ea4856b&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea4856b",
  null
  
)

export default component.exports